export default "__VITE_ASSET__U2EPDv96__"